import React from "react";
import { Eraser } from "lucide-react";
import { Button } from "../../../../shared/components/ui/Button";
import { FormField } from "../../../../shared/components/forms/FormField";

export interface UserFilterProps {
  name: string;
  citizenshipNumber: string;
  onNameChange: (value: string) => void;
  onCitizenshipChange: (value: string) => void;
  onClearFilters: () => void;
}

/**
 * UserFilters
 * A responsive and well-balanced layout for filtering users.
 * - Stacked on mobile
 * - Two-column layout on desktop
 * - Prevents full-width stretched inputs for better readability
 */
export const UserFilter: React.FC<UserFilterProps> = ({
  name,
  citizenshipNumber,
  onNameChange,
  onCitizenshipChange,
  onClearFilters,
}) => {
  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className="flex flex-col gap-4 mb-5"
    >
      {/* Responsive two-column grid for filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto w-full">
        <FormField
          type="input" // ✅ required to match FormField discriminated union
          label="Nombre"
          inputProps={{
            type: "text",
            placeholder: "Filtrar por nombre",
            value: name,
            onChange: (e) => onNameChange(e.target.value),
          }}
        />

        <FormField
          type="input" // ✅ required
          label="Cédula de ciudadanía"
          inputProps={{
            type: "text",
            placeholder: "Filtrar por cédula",
            value: citizenshipNumber,
            onChange: (e) => onCitizenshipChange(e.target.value),
          }}
        />
      </div>

      {/* Align clear button with inputs */}
      <div className="flex justify-end max-w-3xl mx-auto w-full">
        <Button
          type="button"
          onClick={onClearFilters}
          variant="secondary"
          className="h-11 w-11 p-2 flex items-center justify-center shrink-0"
          title="Limpiar filtros"
          aria-label="Limpiar filtros"
        >
          <Eraser className="shrink-0" />
        </Button>
      </div>
    </form>
  );
};
